import { uid } from '../../../../lib/uid';

/**
 * A synthetic training report, for exercising the Submit report form — Autogenerate.
 *
 * Markup the editor itself would produce (paragraphs, bold, a list), so the server's allow-list
 * keeps all of it. Obviously a sample: the tag makes each one unique and nothing reads as a real
 * account of a real training.
 *
 * A rich-text editor is UNCONTROLLED after mount, so the form that generates this must REMOUNT its
 * editor (a `key` it bumps) for the sample to show — setting the value alone would not.
 */
export function sampleTrainingReport(trainingTitle: string): string {
  const tag = uid().slice(0, 6).toUpperCase();

  return [
    `<p><strong>Sample training report ${tag}</strong></p>`,
    `<p>A sample report on ${trainingTitle}, written so the form can be tried end to end.</p>`,
    '<ul><li><p>What it covered: the fundamentals, with a practical exercise.</p></li><li><p>What I took from it: a method I can apply on a live assignment.</p></li><li><p>What comes next: use it at work, then review progress against the target level.</p></li></ul>',
  ].join('');
}
